<template>
    <div style="max-width:1400px;">
        <v-row justify="center" align="center">
            <v-col cols=12 md=6>
                <div class="text-h4 text-md-h2 text-center primary--text font-weight-light">Proposal - Builder</div>
            </v-col>                
        </v-row>
        <v-card
        :min_width=min_width
        elevation=0
        class="rounded-card"
        >
        <v-card-text>
            <v-row class="pr-5 pl-5">
                <v-col cols="12">
                        <!-- Opportunity -->
                        <v-card class="mt-6 section">
                            <v-card-title class="primary section-title">
                                <div class="white--text text-h5 font-weight-regular">Prospect: {{ client.client_name }}</div>
                            </v-card-title>
                            <v-card-text>
                                <v-row >
                                    <v-col cols=12 md=3>
                                        <v-autocomplete
                                        v-model="planOpportunityViewmodel.planRunner"
                                        outlined
                                        label="Plan Ran For"
                                        :items="userList.users"
                                        item-text="user_name"
                                        hide-details
                                        item-value="user_id"
                                        return-object
                                        @change="updatePlanOpp"
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols=12 md=3>
                                        <v-text-field
                                        label='Sales Probabilty'
                                        v-model="planOpportunityViewmodel.plan_opportunity.sales_probability"
                                        hide-details
                                        outlined
                                        v-mask="percentageMask"
                                        @change="updatePlanOpp"
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols=12 md=3>
                                        <v-autocomplete
                                        label="Level of Involvement"
                                        v-model="planOpportunityViewmodel.lois"
                                        :items=loiList
                                        item-text="ddl_name"
                                        item-value="level_of_involvement_id"
                                        return-object
                                        hide-details multiple
                                        outlined
                                        @change="updatePlanOpp"
                                        >
                                            <template slot="selection" slot-scope="data">
                                                {{ data.item.name }}, 
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols=12 md=3>
                                        <v-autocomplete
                                        v-model="planOpportunityViewmodel.plan_opportunity.duration"
                                        outlined
                                        label="Duration"
                                        hide-details
                                        :items="globalContext.listsContext.durations"
                                        return-object
                                        @change="updatePlanOpp"
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- Plan Type -->
                        <v-card class="mt-6 section">
                            <v-card-title class="primary section-title">
                                <div class="white--text text-h5 font-weight-regular">Plan Type</div>
                                <v-spacer>
                                    <div class="text-right">
                                        <v-icon color="teal" v-if="planTypeSection.isComplete">mdi-check</v-icon>
                                        <v-icon color="red" v-else>mdi-checkbox-blank-circle</v-icon>
                                    </div>
                                </v-spacer>
                            </v-card-title>
                            <v-card-text>
                                <v-radio-group
                                v-model="planTypeSection.ParentType"
                                row
                                @change="updateSection('planType')"
                                >
                                    <v-col :cols="12" :lg="2">
                                        <span class="text">Main Type</span>
                                    </v-col>
                                    <v-col
                                    v-for="ParentType in planTypeSection.ParentTypes"
                                    :key="ParentType.id"
                                    :cols="12"                                    
                                    :lg="2"
                                    >
                                        <v-radio :label="ParentType" :value="ParentType"></v-radio>
                                    </v-col>
                                </v-radio-group>
                                <hr>
                                <v-radio-group
                                v-model="planTypeSection.SubType"
                                row
                                @change="updateSection('planType')"
                                v-bind:disabled="planTypeSection.DisableSubType"
                                >
                                    <v-col :cols="12" :lg="2">
                                        <span class="text" style="color:#333;">Sub Type</span>
                                    </v-col>
                                    <v-col
                                    v-for="SubType in planTypeSection.SubTypes"
                                    :key="SubType.id"
                                    :cols="12"                                    
                                    :lg="3"
                                    >
                                        <v-radio :label="SubType" :value="SubType"></v-radio>
                                    </v-col>
                                </v-radio-group>
                                <hr>
                                <v-row cols="12">
                                    <v-col :cols="6" :lg="2">
                                        <v-row>
                                            <span class="text" style="padding-left:24px;color:#333;">Options</span>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="6" lg="3">
                                        <v-checkbox
                                            v-model="planTypeSection.IsMEP"
                                            label="Multiple Employer Plan"
                                            v-bind:disabled="planTypeSection.DisableMEP"
                                            @change="updateSection('planType')"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col cols="6" lg="3">
                                        <v-checkbox
                                            v-model="planTypeSection.IsNoRevenueShare"
                                            label="No Revenue Share"
                                            v-bind:disabled="planTypeSection.DisableNoRevShare"
                                            @change="updateSection('planType')"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col cols="6" lg="3">
                                        <v-checkbox
                                            v-model="planTypeSection.IsTPAChange"
                                            label="TPA Change"
                                            v-bind:disabled="planTypeSection.DisableTPAChange"
                                            @change="updateSection('planType')"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- Cash Balance -->
                        <v-card class="mt-6 section" v-if="showCashBalanceSection">
                            <v-card-title class="primary section-title">
                                <div class="white--text text-h5 font-weight-regular">Cash Balance</div>
                                <v-spacer>
                                    <div class="text-right">
                                        <v-icon color="teal" v-if="cashBalanceSection.isComplete">mdi-check</v-icon>
                                        <v-icon color="red" v-else>mdi-checkbox-blank-circle</v-icon>
                                    </div>
                                </v-spacer>
                            </v-card-title>
                            <v-card-text>
                                <v-radio-group
                                v-model="cashBalanceSection.CBType"
                                row
                                @change="updateSection('cashBalance')"
                                >
                                    <v-col
                                    v-for="CBType in cashBalanceSection.CBTypes"
                                    :key="CBType.id"
                                    :cols="12"                                    
                                    :lg=6
                                    >
                                        <v-radio :label="CBType" :value="CBType"></v-radio>
                                    </v-col>
                                </v-radio-group>
                                <v-col cols=12 md=6 v-if="planTypeSection.isCBOnly">
                                    <v-autocomplete
                                    v-model="cashBalanceSection.Template"
                                    label="Template"
                                    :items="templates"
                                    item-text=template_name
                                    item-value=template_id
                                    return-object
                                    @change="updateSection('cashBalance')"
                                    >
                                    </v-autocomplete>
                                </v-col>
                            </v-card-text>
                        </v-card>

                        <!-- Template -->
                        <v-card class="mt-6 section" v-if="showTemplateSection">
                            <v-card-title class="primary section-title">
                                <div class="white--text text-h5 font-weight-regular">Template</div>
                                <v-spacer>
                                    <div class="text-right">
                                        <v-icon color="teal" v-if="templateSection.isComplete">mdi-check</v-icon>
                                        <v-icon color="red" v-else>mdi-checkbox-blank-circle</v-icon>
                                    </div>
                                </v-spacer>
                            </v-card-title>
                            <v-card-text>
                                <v-col cols=12 md=6>
                                    <v-autocomplete
                                    v-model="templateSection.Template"
                                    label="Template"
                                    :items="templates"
                                    item-text=template_name
                                    item-value=template_id
                                    return-object
                                    @change="updateSection('template')"
                                    >
                                    </v-autocomplete>
                                </v-col>
                            </v-card-text>
                        </v-card>

                        <!-- Revenue Share Program -->
                        <v-card class="mt-6 section" v-if="showRevShareSection">
                            <v-card-title class="primary section-title">
                                <div class="white--text text-h5 font-weight-regular" v-if="!mobile">Revenue Share Program</div>
                                <div class= "white--text text-h5 font-weight-regular" v-else>Rev Share</div>
                                <v-spacer v-if="!mobile"></v-spacer>
                                <v-spacer v-if="!mobile"></v-spacer>
                                <v-spacer v-if="!mobile"></v-spacer>
                                <v-spacer v-if="!mobile"></v-spacer>
                                <v-spacer v-if="!mobile"></v-spacer>
                                <v-switch
                                v-model="revShareSection.multiQuote"
                                label="MultiQuote"
                                dark
                                class="ma-0"
                                hide-details
                                @click.native.stop
                                @change="revShareSection.selected_programs = []"
                                >    
                                </v-switch>
                                <v-spacer></v-spacer>
                                <div class="text-right">
                                    <v-icon color="teal" v-if="revShareSection.isComplete">mdi-check</v-icon>
                                    <v-icon color="red" v-else>mdi-checkbox-blank-circle</v-icon>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-container v-if="!mobile">
                                     <v-item-group 
                                     v-model=revShareSection.selected_programs
                                     :multiple=revShareSection.multiQuote
                                     @change="updateSection('revShare')"
                                     >   
                                        <v-row >
                                            <v-col 
                                            v-for="option in revShareSection.revSharePrograms" 
                                            :key=option.id 
                                            :cols=4
                                            :xl=3
                                            >
                                                 <v-item :value=option >
                                                    <v-layout align-center slot-scope="{ active, toggle }">
                                                        <v-icon :color="active ? 'primary': ''" @click="toggle" class="mr-2"  >
                                                            {{ active ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                                                        </v-icon>
                                                        {{ option.rk_name }}
                                                    </v-layout>
                                                </v-item>
                                            </v-col>
                                         </v-row>
                                    </v-item-group>
                                </v-container>
                                <v-autocomplete
                                  v-else
                                  v-model=revShareSection.selected_programs
                                  :multiple=revShareSection.multiQuote
                                  :items=revShareSection.revSharePrograms
                                  item-text="rk_name"
                                  item-value="rk_id"
                                  @change="updateSection('revShare')"
                                  return-object
                                >
                                </v-autocomplete>
                            </v-card-text>
                        </v-card>

                        <!-- Providers -->
                        <v-card class="mt-6 section" v-if="showProviderSection">
                            <v-card-title class="primary section-title">
                                <div class="white--text text-h5 font-weight-regular">Providers</div>
                                <v-spacer></v-spacer>
                                <div class="text-right">
                                    <v-icon color="teal" v-if="providerSection.isComplete">mdi-check</v-icon>
                                    <v-icon color="red" v-else>mdi-checkbox-blank-circle</v-icon>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-row v-for="wholesalerTemplate in providerSection.wholesalerTemplates" :key=wholesalerTemplate.id>
                                    <v-col cols=12 class="pb-0">
                                        <div class="text-h6 text-md-h5 font-weight-regular primary-text">Provider: {{ wholesalerTemplate.wholesaler_name }}</div>
                                    </v-col>
                                    <v-col cols=12 md=6 >
                                        <v-autocomplete
                                        v-model="wholesalerTemplate.selected_rep_user"
                                        label="Wholesalers"
                                        :items="wholesalerTemplate.rep_users"
                                        item-text=rep_name
                                        item-value=rep_user_id
                                        return-object
                                        @change="updateSection('provider')"
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols=12 md=6>
                                        <v-autocomplete
                                        v-model="wholesalerTemplate.selected_template"
                                        label="Template"
                                        :items="templates"
                                        item-text=template_name
                                        item-value=template_id
                                        return-object
                                        @change="updateSection('provider')"
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                    <v-divider></v-divider>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <!-- Broker Dealer -->
                        <v-card class="mt-6 section" v-if="showBrokerSection">
                            <v-card-title class="primary section-title">
                                <div class="white--text text-h5 font-weight-regular">Broker-Dealer</div>
                                    <v-spacer></v-spacer>
                                    <div class="text-right">
                                        <v-icon color="teal" v-if="brokerSection.isComplete">mdi-check</v-icon>
                                        <v-icon color="red" v-else>mdi-checkbox-blank-circle</v-icon>
                                    </div>
                            </v-card-title>
                            <v-card-text>
                                <v-radio-group 
                                    v-model="brokerSection.radioSelected" 
                                    row
                                    @change="updateSection('broker')"
                                    :disabled="brokerSection.is_no_broker"
                                    >
                                        <v-col
                                        v-for="option in brokerSection.radioOptions"
                                        :key="option.broker_id"
                                        :cols="12"
                                        :md="4"
                                        >
                                            <v-row>
                                                <v-radio :label="option.broker_dealer_name" :value="option"></v-radio>
                                                <v-tooltip top v-if="!option.is_default" >
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon v-on="on" class="text-left" color="amber darken-2">mdi-alert-circle-outline</v-icon>
                                                    </template>
                                                    <span>{{option.broker_dealer_name}} is not shown by default.
                                                        <br>They will be in the 'Other' drop down selection
                                                        <br>the next time you create a proposal.
                                                    </span>
                                                </v-tooltip>
                                            </v-row>
                                        </v-col>
                                        <v-col cols=12 md=4>
                                            <v-row>
                                                <v-col md=4 class="pl-0 pt-0 pb-0">
                                                    <v-radio label="Other" value="Other"></v-radio>
                                                </v-col>
                                                <v-col md=8 class="pl-0 pt-0 pb-0">
                                                    <v-combobox
                                                    v-model="brokerSection.dropDownSelected"
                                                    v-if="brokerSection.radioSelected === 'Other'"
                                                    outlined
                                                    label="Other"
                                                    :items="brokerSection.dropDownOptions"
                                                    item-text="broker_dealer_name"
                                                    item-value="broker_id"
                                                    class="pa-0 ma-0"
                                                    single-line
                                                    return-object
                                                    :rules="[false || 'Select From List']"
                                                    @change="updateSection('broker')"
                                                    ></v-combobox>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-radio-group>
                                <hr>
                                <v-container>
                                    <v-row justify="space-between">
                                        <v-col cols=12 md=6>
                                            <v-text-field
                                            v-model="brokerSection.radioSelected.broker_dealer_name"
                                            label="Broker Dealer Selected"
                                            outlined
                                            disabled
                                            hide-details
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols=12 md=6>
                                            <v-checkbox
                                            v-model="brokerSection.radioSelected.is_default"
                                            label="Show By Default"
                                            :disabled="brokerSection.is_no_broker"
                                            @change="updateBrokerDefault"
                                            >
                                            </v-checkbox>
                                        </v-col>      
                                    </v-row>
                                </v-container>
                                <hr>
                                <v-container>
                                    <v-row>
                                        <v-checkbox
                                        v-model="brokerSection.is_no_broker"
                                        label="No Broker Dealer"
                                        ></v-checkbox>
                                            <v-tooltip top v-if="brokerSection.is_no_broker" >
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-on="on" class="text-left" color="amber darken-2">mdi-alert-circle-outline</v-icon>
                                                </template>
                                                <span>We highly recommend only
                                                    <br>using this option when there
                                                    <br>is actually no broker-dealer.
                                                </span>
                                            </v-tooltip>
                                    </v-row>
                                    <v-dialog
                                    v-model="brokerSection.confirmNoBroker"
                                    :retain-focus="false"
                                    persistent
                                    max-width="360px"
                                    >
                                        <v-card>
                                            <v-card-title>
                                                <v-spacer></v-spacer>
                                                <span class="red--text font-weight-bold">Are You Sure?</span>
                                                <v-spacer></v-spacer>
                                            </v-card-title>
                                            <br>
                                            <v-card-text class="text-justify">
                                                You will not be able to change
                                                <br>this after the proposal has been
                                                <br>generated!
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                color="primary"
                                                @click="handleNoBrokerSelect(true)"
                                                >
                                                    YES
                                                </v-btn>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                color="primary"
                                                @click="handleNoBrokerSelect(false)">
                                                    NO
                                                </v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-container>
                            </v-card-text>
                        </v-card>

                        <!-- Advisor -->
                        <v-card class="mt-6 section" v-if="showAdvisorSection">
                            <v-card-title class="primary section-title">
                                <div class="white--text text-h5 font-weight-regular">Advisor</div>
                                <v-spacer></v-spacer>
                                <div class="text-right">
                                    <v-icon color="teal" v-if="advisorSection.isComplete">mdi-check</v-icon>
                                    <v-icon color="red" v-else>mdi-checkbox-blank-circle</v-icon>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-radio-group
                                    v-model="advisorSection.radioSelected"
                                    row
                                    @change="updateSection('advisor')"
                                    >       
                                        <v-col
                                        v-for="option in advisorSection.radioOptions"
                                        :key="option.id"
                                        :cols="12"
                                        :md="4"
                                        >
                                            <v-row>
                                                <v-radio :label="option.advisor_name" :value="option"></v-radio>
                                                <v-tooltip top v-if="!option.is_default" >
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon v-on="on" class="text-left" color="amber darken-2">mdi-alert-circle-outline</v-icon>
                                                    </template>
                                                    <span>{{option.advisor_name}} is not shown by default. They  
                                                        <br>will be in the drop down selection the next 
                                                        <br>time you select {{brokerSection.radioSelected.broker_dealer_name}}.</span>
                                                </v-tooltip>
                                            </v-row>
                                        </v-col>
                                        <v-col cols=12 md=4>
                                            <v-row>
                                                <v-col md=4 class="pl-0 pt-0 pb-0">
                                                    <v-radio label="Other" value="Other"></v-radio>
                                                </v-col>
                                                <v-col md=8 class="pl-0 pt-0 pb-0">
                                                    <v-combobox
                                                    v-model="advisorSection.dropDownSelected"
                                                    v-if="advisorSection.radioSelected === 'Other'"
                                                    outlined
                                                    label="Select or Enter New"
                                                    :items=advisorSection.dropDownOptions
                                                    item-text="advisor_name"
                                                    item-value="advisor_id"
                                                    class="pa-0 ma-0"
                                                    single-line
                                                    return-object
                                                    hide-details
                                                    ></v-combobox>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                </v-radio-group>
                                <hr>
                                <v-container>
                                    <v-row justify="space-between">
                                        <v-col cols=12 md=5>
                                            <v-autocomplete
                                                v-model="advisorSection.brokerSelected"
                                                outlined
                                                label="Broker Dealer Name"
                                                :items="advisorSection.brokerOptions"
                                                item-text="broker_dealer_name"
                                                item-value="broker_id"
                                                v-bind:disabled="advisorSection.disableForm"
                                                return-object
                                                hide-details
                                                @change="advisorSection.confirm = true"
                                            ></v-autocomplete>
                                            <v-dialog
                                            v-model="advisorSection.confirm"
                                            :retain-focus="false"
                                            persistent
                                            max-width="360px"
                                            >
                                                <v-card>
                                                    <v-card-title>
                                                        <v-spacer></v-spacer>
                                                        <span class="red--text font-weight-bold">Are You Sure?</span>
                                                        <v-spacer></v-spacer>
                                                    </v-card-title>
                                                    <br>
                                                    <v-card-text class="text-justify">
                                                        You are about to change the Broker that {{advisorSection.radioSelected.advisor_name}}
                                                        is associated with. They will be removed from the current option list.
                                                        You will need to select {{advisorSection.brokerSelected.broker_dealer_name}} to select them again.
                                                    </v-card-text>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                        color="primary"
                                                        @click="updateAdvisorBroker"
                                                        >
                                                            YES
                                                        </v-btn>
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                        color="primary"
                                                        @click="advisorSection.confirm = false">
                                                            NO
                                                        </v-btn>
                                                        <v-spacer></v-spacer>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-col>    
                                        <v-col cols=12 md=5>
                                            <v-text-field
                                                v-model="advisorSection.radioSelected.advisor_firm_name"
                                                label="Advisor Firm Name"
                                                outlined
                                                hide-details
                                                v-bind:disabled=advisorSection.disableForm
                                                @change="updateAdvisorObj"
                                            ></v-text-field>
                                        </v-col>    
                                    </v-row>
                                    <v-row justify="space-between">
                                        <v-col cols=12 md=5>
                                            <v-text-field
                                                v-model="advisorSection.radioSelected.advisor_name"
                                                label="* Advisor Name"
                                                outlined
                                                hide-details
                                                v-bind:disabled=advisorSection.disableForm
                                                @change="updateAdvisorObj"
                                            ></v-text-field>
                                        </v-col>    
                                        <v-col cols=12 md=5>
                                            <v-text-field
                                                v-model="advisorSection.radioSelected.advisor_email"
                                                label="Advisor Email"
                                                outlined
                                                hide-details
                                                v-bind:disabled=advisorSection.disableForm
                                                @change="updateAdvisorObj"
                                            ></v-text-field>
                                        </v-col>  
                                    </v-row>
                                    <v-row justify="space-between">
                                        <v-col cols=12>
                                            <v-text-field
                                                v-model="advisorSection.radioSelected.advisor_address"
                                                label="Advisor Address"
                                                outlined
                                                hide-details
                                                v-bind:disabled=advisorSection.disableForm
                                                @change="updateAdvisorObj"
                                            ></v-text-field>
                                        </v-col>  
                                    </v-row>
                                    <v-row justify="space-between">
                                        <v-col cols=12 md=3>
                                            <v-text-field
                                                v-model="advisorSection.radioSelected.advisor_state"
                                                label="Advisor State"
                                                outlined
                                                hide-details
                                                v-bind:disabled=advisorSection.disableForm
                                                @change="updateAdvisorObj"
                                            ></v-text-field>
                                        </v-col>    
                                        <v-col cols=12 md=3>
                                            <v-text-field
                                                v-model="advisorSection.radioSelected.advisor_city"
                                                label="Advisor City"
                                                outlined
                                                hide-details
                                                v-bind:disabled=advisorSection.disableForm
                                                @change="updateAdvisorObj"
                                            ></v-text-field>
                                        </v-col>    
                                        <v-col cols=12 md=3>
                                            <v-text-field
                                                v-model="advisorSection.radioSelected.advisor_zip"
                                                label="Advisor Zipcode"
                                                outlined
                                                hide-details
                                                v-bind:disabled=advisorSection.disableForm
                                                @change="updateAdvisorObj"
                                            ></v-text-field>
                                        </v-col>  
                                        <v-col cols=12 md=3>
                                            <v-checkbox
                                                v-model="advisorSection.radioSelected.is_default"
                                                label="Show By Default"
                                                v-bind:disabled=advisorSection.disableForm
                                                @change="updateAdvisorObj"
                                            ></v-checkbox>
                                        </v-col>    
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>

                        <!-- Pricing -->
                        <v-card class="mt-6 section" v-if="showPricingSection">
                            <v-card-title class="primary section-title">
                                <div class="white--text text-h5 font-weight-regular">Pricing</div>
                                <v-spacer></v-spacer>
                                <!-- Other Pricing Options -->
                                <template>
                                    <v-dialog
                                    v-model="pricingComponentDialog"
                                    scrollable
                                    max-width="300px"
                                    >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        style="margin-right:20px;"
                                        class="not-caps"
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                        Other Pricing Components
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title style="justify-content:center;">Select Components</v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text style="height:300px;">
                                            <div style="height:20px"></div>
                                            <v-checkbox
                                                class="componentList"
                                                v-model="pricingSection.plan_doc_maint.is_shown"
                                                @change="selectOtherPricingComponent('plan_doc_maint')"
                                                label="Plan Document Maintenance">
                                            </v-checkbox>
                                            <v-checkbox 
                                                class="componentList"
                                                v-model="pricingSection.audit_fee.is_shown"
                                                @change="selectOtherPricingComponent('audit_fee')"
                                                label="Audit Fee">
                                            </v-checkbox>
                                            <v-checkbox 
                                                class="componentList"
                                                v-model="pricingSection.three_sixteen.is_shown"
                                                @change="selectOtherPricingComponent('three_sixteen')"
                                                label="3(16)">
                                            </v-checkbox>
                                            <v-checkbox 
                                                class="componentList"
                                                v-model="pricingSection.payroll_integration.is_shown"
                                                @change="selectOtherPricingComponent('payroll_integration')"
                                                label="Payroll Integration">
                                            </v-checkbox>
                                            <v-checkbox 
                                                class="componentList"
                                                v-model="pricingSection.payroll_processing.is_shown"
                                                @change="selectOtherPricingComponent('payroll_processing')"
                                                label="Payroll Processing">
                                            </v-checkbox>
                                            <v-checkbox 
                                                class="componentList"
                                                v-model="pricingSection.custom_additions.is_shown"
                                                @change="selectOtherPricingComponent('custom_additions')"
                                                label="Custom Additions">
                                            </v-checkbox>
                                            <v-checkbox 
                                                class="componentList"
                                                v-model="pricingSection.custom_notes.is_shown"
                                                @change="selectOtherPricingComponent('custom_notes')"
                                                label="Custom Notes">
                                            </v-checkbox>
                                            <v-checkbox 
                                                class="componentList"
                                                v-model="pricingSection.pbgc.is_shown"
                                                v-if="!this.planTypeSection.isCBType"
                                                @change="selectOtherPricingComponent('pbgc')"
                                                :disabled="pbgcIsDisabled"
                                                label="PBGC"
                                                persistent-hint
                                                hint="Does not apply to 401(k) & 403(b) plans.">
                                            </v-checkbox> 
                                            <v-checkbox 
                                                class="componentList"
                                                v-model="pricingSection.pbgc.is_shown"
                                                v-if="this.planTypeSection.isCBType"
                                                @change="selectOtherPricingComponent('pbgc')"
                                                label="PBGC">
                                            </v-checkbox>                            
                                        </v-card-text>
                                        <v-divider></v-divider>
                                        <v-card-actions>
                                        <v-btn
                                            color="blue darken-1"
                                            text
                                            @click="pricingComponentDialog = false"
                                        >Close</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                    </v-dialog>
                                </template>
                                <div class="text-right">
                                    <v-icon color="teal" v-if="pricingSection.isComplete">mdi-check</v-icon>
                                    <v-icon color="red" v-else>mdi-checkbox-blank-circle</v-icon>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <!-- Errors -->
                                <v-row v-if="pricingSection.errors.length > 0">
                                    <li 
                                    v-for="error in pricingSection.errors" 
                                    :key="error.id"
                                    class="error-msg"
                                    >
                                    {{ error.message }}
                                    </li>
                                </v-row>

                                <!-- Pricing Assumptions -->
                                <v-row v-if="develop">
                                    pricing_assumptions: {{pricingSection.pricing_assumptions}}
                                </v-row>
                                <v-row v-if="pricingSection.pricing_assumptions.is_shown" justify="space-between">
                                    <v-col cols=12 md=4>
                                        <v-text-field
                                            v-model="pricingSection.pricing_assumptions.plan_assets.value"
                                            label="Plan Assets"
                                            outlined
                                            v-mask="curreMask"
                                            hide-details
                                            :disabled="disablePlanAssets"
                                            @change="updateSection('pricing')"
                                        ></v-text-field>
                                    </v-col> 
                                    <v-col cols=12 md=4>
                                        <v-text-field
                                            v-model="pricingSection.pricing_assumptions.annual_contributions.value"
                                            label="* Annual Contributions"
                                            outlined
                                            v-mask="curreMask"
                                            hide-details
                                            @change="updateSection('pricing')"
                                        ></v-text-field>
                                    </v-col> 
                                    <v-col cols=12 md=4>
                                        <v-text-field
                                            v-model="pricingSection.pricing_assumptions.participants_with_balance.value"
                                            label="* Participants With A Balance"
                                            outlined
                                            v-mask="numMask"
                                            hide-details
                                            @change="updateSection('pricing')"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <!-- Standard Fees -->
                                <v-row v-if="develop">
                                    standard_fees: {{pricingSection.standard_fees}}
                                </v-row>
                                <v-row v-if="pricingSection.standard_fees.is_shown" justify="space-between">
                                    <v-col cols=2 md=2 >
                                            <v-combobox
                                            v-model=pricingSection.standard_fees.design_installation.value
                                            label="Design - Installation Fee"
                                            :items=pricingOptions.standard_fees.design_installation
                                            v-mask="curreMask"
                                            @change="updateSection('pricing')"
                                            >
                                            </v-combobox>
                                    </v-col>
                                    <v-col cols=2 md=2 >
                                            <v-combobox
                                            v-model=pricingSection.standard_fees.install_participant.value
                                            label="Install Participant Fee"
                                            :items=pricingOptions.standard_fees.install_participant
                                            v-mask="curreMask"
                                            @change="updateSection('pricing')"
                                            >
                                            </v-combobox>
                                    </v-col>
                                    <v-col cols=2 md=2 >
                                            <v-combobox
                                            v-model=pricingSection.standard_fees.annual_participant.value
                                            label="Annual Participant Fee"
                                            :items=pricingOptions.standard_fees.annual_participant
                                            v-mask="curreMask"
                                            @change="updateSection('pricing')"
                                            >
                                            </v-combobox>
                                    </v-col>
                                    <v-col cols=2 md=2 >
                                            <v-combobox
                                            v-model=pricingSection.standard_fees.annual_admin.value
                                            label="Annual Admin Fee"
                                            :items=pricingOptions.standard_fees.annual_admin
                                            v-mask="curreMask"
                                            @change="updateSection('pricing')"
                                            >
                                            </v-combobox>
                                    </v-col>
                                    <v-col cols=2 md=2 >
                                            <v-combobox
                                            v-model=pricingSection.standard_fees.document.value
                                            label="Design & Document Fee"
                                            :items=pricingOptions.standard_fees.document
                                            v-mask="curreMask"
                                            @change="updateSection('pricing')"
                                            >
                                            </v-combobox>
                                    </v-col>
                                </v-row>

                                <!-- MEP -->
                                <v-row v-if="develop">
                                    mep_pricing: {{pricingSection.mep_pricing}}
                                </v-row>
                                <v-row v-if="pricingSection.mep_pricing.is_shown">
                                    <v-col cols=6 md=3>
                                        <v-text-field
                                            v-model="pricingSection.mep_pricing.plan_assets.value"
                                            label="Plan Assets"
                                            outlined
                                            v-mask="curreMask"
                                            :disabled="disablePlanAssets"
                                            hide-details
                                            @change="updateSection('pricing')"
                                        ></v-text-field>
                                    </v-col> 
                                    <v-col cols=6 md=3>
                                        <v-text-field
                                            v-model="pricingSection.mep_pricing.annual_contributions.value"
                                            label="* Annual Contributions"
                                            outlined
                                            v-mask="curreMask"
                                            hide-details
                                            @change="updateSection('pricing')"
                                        ></v-text-field>
                                    </v-col> 
                                    <v-col cols=6 md=3 >
                                        <v-combobox
                                        v-model="pricingSection.mep_pricing.sponsor_document.value"
                                        label="Plan Sponsor - Plan Document"
                                        :items="pricingOptions.mep_pricing.sponsor_document"
                                        v-mask="curreMask"
                                        @change="updateSection('pricing')"
                                        >
                                        </v-combobox>
                                    </v-col>
                                    <v-col cols=6 md=3 >
                                        <v-combobox
                                        v-model="pricingSection.mep_pricing.adopting_employer.value"
                                        label="Adopting Employer Agreement"
                                        :items="pricingOptions.mep_pricing.adopting_employer"
                                        v-mask="curreMask"
                                        @change="updateSection('pricing')"
                                        >
                                        </v-combobox>
                                    </v-col>
                                </v-row>
                                <v-row v-if="pricingSection.mep_pricing.is_shown">
                                    <v-col cols=6 md=3 class='mep-title'>
                                        MEP Tier Pricing
                                    </v-col>
                                    <v-col cols=6 md=3 >
                                        <v-btn
                                        color="red lighten-2"
                                        dark
                                        @click="removeUnusedMEPTiers"
                                        >Remove Unused Tiers</v-btn>
                                    </v-col>
                                    <v-col cols=6 md=3 >
                                        <v-btn
                                        color="red lighten-2"
                                        dark
                                        @click="resetTierMEPPricing"
                                        >Reset Tiers</v-btn>
                                    </v-col>
                                </v-row>
                                <div v-if="pricingSection.mep_pricing.is_shown">
                                <v-row justify="space-between" v-for="group in pricingSection.mep_pricing.groups" :key="group.id">
                                    <v-col cols=2 md=2 >
                                        <v-combobox
                                        v-model=group.tier_level.value
                                        label="Tier Level"
                                        :items=pricingOptions.mep_pricing.tiers
                                        @change="updateSection('pricing')"
                                        >
                                        </v-combobox>
                                    </v-col>
                                    <v-col cols=2 md=2 >
                                        <v-combobox
                                        v-model="group.per_company.value"
                                        label="Per Company Fee"
                                        :items="pricingOptions.mep_pricing.per_company"
                                        v-mask="curreMask"
                                        @change="updateSection('pricing')"
                                        >
                                        </v-combobox>
                                    </v-col>
                                    <v-col cols=2 md=2 >
                                        <v-text-field
                                        v-model="group.company_count.value"
                                        label="Number of Companies"
                                        v-mask="numMask"
                                        @change="updateSection('pricing')"
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols=2 md=2 >
                                        <v-combobox
                                        v-model="group.per_participant.value"
                                        label="Per Participant Fee"
                                        :items="pricingOptions.mep_pricing.per_participant"
                                        v-mask="curreMask"
                                        @change="updateSection('pricing')"
                                        >
                                        </v-combobox>
                                    </v-col>
                                    <v-col cols=2 md=2 >
                                        <v-text-field
                                        v-model="group.participant_count.value"
                                        label="Number of Participants"
                                        v-mask="numMask"
                                        @change="updateSection('pricing')"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                </div>

                                <!-- Plan Doc Maint -->
                                <hr v-if="pricingSection.plan_doc_maint.is_shown">
                                <v-row v-if="develop">
                                    plan_doc_maint: {{pricingSection.plan_doc_maint}}
                                </v-row>
                                <v-row v-if="pricingSection.plan_doc_maint.is_shown">
                                    <v-col cols=3 md=3>
                                        <v-checkbox
                                            v-model="pricingSection.plan_doc_maint.is_checked"
                                            label="Plan Document Maintenance"
                                            @change="updateSection('pricing')"
                                        ></v-checkbox>
                                    </v-col> 
                                    <v-col cols=3 md=3 >
                                            <v-combobox
                                            v-model=pricingSection.plan_doc_maint.fee.value
                                            :items=pricingOptions.plan_doc_maint.fee
                                            :disabled="!pricingSection.plan_doc_maint.is_checked"
                                            v-mask="curreMask"
                                            @change="updateSection('pricing')"
                                            >
                                            </v-combobox>
                                    </v-col>
                                </v-row>

                                <!-- Audit Fees -->
                                <hr v-if="pricingSection.audit_fee.is_shown">
                                <v-row v-if="develop">
                                    audit_fee: {{pricingSection.audit_fee}}
                                </v-row>
                                <v-row v-if="pricingSection.audit_fee.is_shown">
                                    <v-col cols=3 md=3>
                                        <v-checkbox
                                            v-model="pricingSection.audit_fee.is_checked"
                                            label="Audit Fee"
                                            @change="updateSection('pricing')"
                                        ></v-checkbox>
                                    </v-col> 
                                    <v-col cols=3 md=3 >
                                            <v-combobox
                                            v-model=pricingSection.audit_fee.fee.value
                                            :items=pricingOptions.audit_fee.fee
                                            :disabled="!pricingSection.audit_fee.is_checked"
                                            v-mask="curreMask"
                                            @change="updateSection('pricing')"
                                            >
                                            </v-combobox>
                                    </v-col>
                                </v-row>

                                <!-- 3(16) -->
                                <hr v-if="pricingSection.three_sixteen.is_shown">
                                <v-row v-if="develop">
                                    three_sixteen: {{pricingSection.three_sixteen}}
                                </v-row>
                                <v-row v-if="pricingSection.three_sixteen.is_shown">
                                    <v-col md=3>
                                        <v-checkbox
                                            v-model="pricingSection.three_sixteen.is_checked"
                                            label="3(16)"
                                            @change="updateSection('pricing')"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col md=9>
                                        <v-row>
                                            <v-col :md="3">
                                                <v-checkbox 
                                                    v-model="pricingSection.three_sixteen.use_basis_points.value"
                                                    label="Use Basis Points"
                                                    @change="updateSection('pricing')"
                                                    :disabled="!pricingSection.three_sixteen.is_checked"
                                                ></v-checkbox>
                                            </v-col>
                                            <v-col :md="3">
                                                <v-text-field
                                                v-model="pricingSection.three_sixteen.basis_points.value"
                                                label="Basis Points"
                                                :disabled="disableThreeSixteenBasisPoints"
                                                v-mask="numMask"
                                                @change="updateSection('pricing')"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    <v-radio-group
                                    v-model="pricingSection.three_sixteen.calculate_on_opt"                             
                                    @change="updateSection('pricing')"
                                    :disabled="pricingSection.mep_pricing.is_checked || disableThreeSixteenCalculations"
                                    row
                                    >
                                        <v-col :md="2">
                                            <div v-if="!disableThreeSixteenCalculations" style="color:rgba(0, 0, 0, 0.6);">
                                            Calculate on:
                                            </div>
                                            <div v-else style="color:rgba(0, 0, 0, 0.38);">
                                            Calculate on:
                                            </div>
                                        </v-col>
                                            <v-col
                                            v-for="option in pricingSection.three_sixteen.calculate_on_opts"
                                            :key="option.id"
                                            :md="4"
                                            >
                                                <v-radio 
                                                :label="option.label" 
                                                :value="option"
                                                :disabled="!pricingSection.three_sixteen.is_checked">
                                                </v-radio>
                                            </v-col>
                                    </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row v-if="pricingSection.three_sixteen.is_shown" justify="space-between">
                                    <v-col cols=2 md=2 >
                                        <v-combobox
                                        v-model="pricingSection.three_sixteen.service_tier.value"
                                        label="Service Tier"
                                        :items="pricingOptions.three_sixteen.service_tier"
                                        :disabled="!pricingSection.three_sixteen.is_checked"
                                        @change="updateSection('pricing')"
                                        >
                                        </v-combobox>
                                    </v-col>
                                    <v-col cols=2 md=2 >
                                        <v-combobox
                                        v-model="pricingSection.three_sixteen.setup_install.value"
                                        label="Setup and Install Fee"
                                        :items="pricingOptions.three_sixteen.setup_install"
                                        :disabled="disableThreeSixteenCalculations"
                                        v-mask="curreMask"
                                        @change="updateSection('pricing')"
                                        >
                                        </v-combobox>
                                    </v-col>
                                    <v-col cols=2 md=2 >
                                        <v-combobox
                                        v-model="pricingSection.three_sixteen.annual_admin.value"
                                        label="Base Annual Admin Fee"
                                        :items="pricingOptions.three_sixteen.annual_admin"
                                        :disabled="disableThreeSixteenCalculations"
                                        v-mask="curreMask"
                                        @change="updateSection('pricing')"
                                        >
                                        </v-combobox>
                                    </v-col>
                                    <v-col cols=2 md=2 >
                                        <v-combobox
                                        v-model="pricingSection.three_sixteen.annual_participant.value"
                                        label="Annual Fees Per Participant"
                                        :items="pricingOptions.three_sixteen.annual_participant"
                                        :disabled="disableThreeSixteenCalculations"
                                        v-mask="curreMask"
                                        @change="updateSection('pricing')"
                                        >
                                        </v-combobox>
                                    </v-col>
                                    <v-col cols=2 md=2 >
                                        <v-text-field
                                        v-model="pricingSection.three_sixteen.participants_eligible.value"
                                        label="Eligible Participants"
                                        :disabled="disableThreeSixteenEligibleParticipants"
                                        v-mask="numMask"
                                        @change="updateSection('pricing')"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                                <!-- Payroll Integration -->
                                <hr v-if="pricingSection.payroll_integration.is_shown">
                                <v-row v-if="develop">
                                    payroll_integration: {{pricingSection.payroll_integration}}
                                </v-row>
                                <v-row v-if="pricingSection.payroll_integration.is_shown">
                                    <v-col cols=3 md=3>
                                        <v-checkbox
                                            v-model="pricingSection.payroll_integration.is_checked"
                                            label="Payroll Integration"
                                            @change="updateSection('pricing')"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col cols=9 md=9>
                                        <v-row>
                                            <v-col cols=3 md=3 >
                                                    <v-combobox
                                                    v-model=pricingSection.payroll_integration.pi_base_fee.value
                                                    label="Base Fee"
                                                    :items=pricingOptions.payroll_integration.pi_base_fee
                                                    :disabled="!pricingSection.payroll_integration.is_checked"
                                                    v-mask="curreMask"
                                                    @change="updateSection('pricing')"
                                                    >
                                                    </v-combobox>
                                            </v-col>
                                            <v-col cols=3 md=3 >
                                                    <v-text-field
                                                    v-model=pricingSection.payroll_integration.pi_num_payroll.value
                                                    label="Number of Payrolls"
                                                    :disabled="!pricingSection.payroll_integration.is_checked"
                                                    v-mask="numMask"
                                                    @change="updateSection('pricing')"
                                                    >
                                                    </v-text-field>
                                            </v-col>
                                            <v-col cols=3 md=3 >
                                                    <v-combobox
                                                    v-model=pricingSection.payroll_integration.pi_per_emp.value
                                                    label="Per Employee"
                                                    :items=pricingOptions.payroll_integration.pi_per_emp
                                                    :disabled="!pricingSection.payroll_integration.is_checked"
                                                    v-mask="curreMask"
                                                    @change="updateSection('pricing')"
                                                    >
                                                    </v-combobox>
                                            </v-col>
                                            <v-col cols=3 md=3 >
                                                    <v-text-field
                                                    v-model=pricingSection.payroll_integration.pi_num_emp.value
                                                    label="Number of Employees"
                                                    :disabled="!pricingSection.payroll_integration.is_checked"
                                                    v-mask="numMask"
                                                    @change="updateSection('pricing')"
                                                    >
                                                    </v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <!-- Payroll Processing -->
                                <hr v-if="pricingSection.payroll_processing.is_shown">
                                <v-row v-if="develop">
                                    payroll_processing: {{pricingSection.payroll_processing}}
                                </v-row>
                                <v-row v-if="pricingSection.payroll_processing.is_shown">
                                    <v-col cols=3 md=3>
                                        <v-checkbox
                                            v-model="pricingSection.payroll_processing.is_checked"
                                            label="Payroll Processing"
                                            @change="updateSection('pricing')"
                                        ></v-checkbox>
                                    </v-col> 
                                    <v-col cols=3 md=3 >
                                            <v-combobox
                                            v-model=pricingSection.payroll_processing.unit_price.value
                                            label="Per Payroll"
                                            :items=pricingOptions.payroll_processing.unit_price
                                            :disabled="!pricingSection.payroll_processing.is_checked"
                                            v-mask="curreMask"
                                            @change="updateSection('pricing')"
                                            >
                                            </v-combobox>
                                    </v-col>
                                    <v-col cols=3 md=3 >
                                            <v-text-field
                                            v-model=pricingSection.payroll_processing.quantity.value
                                            label="Number of Payrolls"
                                            :disabled="!pricingSection.payroll_processing.is_checked"
                                            v-mask="numMask"
                                            @change="updateSection('pricing')"
                                            >
                                            </v-text-field>
                                    </v-col>
                                </v-row>

                                <!-- Custom Additions -->
                                <hr v-if="pricingSection.custom_additions.is_shown">
                                <v-row v-if="develop">
                                    custom_additions: {{pricingSection.custom_additions}}
                                </v-row>
                                <v-row v-if="pricingSection.custom_additions.is_shown">
                                    <v-col cols=3 md=3>
                                        <v-checkbox
                                            v-model="pricingSection.custom_additions.is_checked"
                                            label="Custom Additions"
                                            @change="updateSection('pricing')"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <div v-if="pricingSection.custom_additions.is_shown">
                                    <v-row
                                    v-for="group in pricingSection.custom_additions.groups"
                                    :key="group.id">
                                        <v-spacer></v-spacer>
                                        <v-checkbox
                                        style='margin-top:26px;'
                                        v-model=group.is_checked.value
                                        :disabled="!pricingSection.custom_additions.is_checked"
                                        :md="1"
                                        >
                                        </v-checkbox>
                                        <v-col cols=7 md=7 >
                                            <v-combobox
                                            v-model=group.description.value
                                            label="Description"
                                            :items=pricingOptions.custom_additions.description
                                            @change="updateSection('pricing')"
                                            :disabled="!pricingSection.custom_additions.is_checked || !group.is_checked.value"
                                            >
                                            </v-combobox>
                                        </v-col>
                                        <v-col cols=2 md=2 >
                                            <v-text-field
                                            v-model=group.value.value
                                            label="Value"
                                            @change="updateSection('pricing')"
                                            v-mask="curreMask"
                                            :disabled="!pricingSection.custom_additions.is_checked || !group.is_checked.value"
                                            >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </div>

                                <!-- Custom Notes -->
                                <hr v-if="pricingSection.custom_notes.is_shown">
                                <v-row v-if="develop">
                                    custom_notes: {{pricingSection.custom_notes}}
                                </v-row>
                                <v-row v-if="pricingSection.custom_notes.is_shown">
                                    <v-col cols=3 md=3>
                                        <v-checkbox
                                            v-model="pricingSection.custom_notes.is_checked"
                                            label="Custom Notes"
                                            @change="updateSection('pricing')"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                                <div v-if="pricingSection.custom_notes.is_shown">
                                    <v-row
                                    v-for="group in pricingSection.custom_notes.groups"
                                    :key="group.id">
                                        <v-spacer></v-spacer>
                                        <v-checkbox
                                        style='margin-top:26px;'
                                        v-model=group.is_checked.value
                                        :disabled="!pricingSection.custom_notes.is_checked"
                                        :md="1"
                                        >
                                        </v-checkbox>
                                        <v-col cols=7 md=7 >
                                            <v-combobox
                                            v-model=group.description.value
                                            label="Note"
                                            :items=pricingOptions.custom_notes.description
                                            @change="updateSection('pricing')"
                                            :disabled="!pricingSection.custom_notes.is_checked || !group.is_checked.value"
                                            >
                                            </v-combobox>
                                        </v-col>
                                        <v-col cols=2 md=2 >
                                            <v-text-field
                                            v-model=group.value.value
                                            label="Value"
                                            @change="updateSection('pricing')"
                                            :disabled="!pricingSection.custom_notes.is_checked || !group.is_checked.value"
                                            >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </div>

                                <!-- PBGC -->
                                <hr v-if="pricingSection.pbgc.is_shown">
                                <v-row v-if="develop">
                                    pbgc: {{pricingSection.pbgc}}
                                </v-row>
                                <v-row v-if="pricingSection.pbgc.is_shown">
                                    <v-col cols=3 md=3>
                                        <v-checkbox
                                            v-model="pricingSection.pbgc.is_checked"
                                            label="PBGC"
                                            @change="updateSection('pricing')"
                                        ></v-checkbox>
                                    </v-col> 
                                    <v-col cols=3 md=3>
                                        <v-text-field
                                        v-model=pricingSection.pbgc.premium_filing.value
                                        label="Comprehensive Premium Filing"
                                        :disabled="!pricingSection.pbgc.is_checked"
                                        v-mask="curreMask"
                                        @change="updateSection('pricing')"
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols=3 md=3 >
                                        <v-text-field
                                        v-model=pricingSection.pbgc.per_participant.value
                                        :class="{appearEnabled:appearEnabled}"
                                        label="Per Participant"
                                        :disabled="true"
                                        v-mask="curreMask"
                                        @change="updateSection('pricing')"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <v-card-actions>
                                <v-col cols=12 md=2 xl=1>
                                    <v-btn 
                                    large 
                                    :disabled="!pricingSection.isComplete" 
                                    color="primary" 
                                    @click="getCalculations">
                                    Calculate
                                    <v-icon right>mdi-arrow-right</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-card-actions>
                        </v-card>

                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions class="pl-5 pr-5 pb-5">
            <v-row class="pl-5 pl-5">
            <v-col cols=12 md=2>
                <v-dialog
                    v-model="cancelProposalDialog"
                    max-width="350"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="red lighten-2"
                        dark
                        large
                        v-bind="attrs"
                        v-on="on "
                    >Cancel Proposal</v-btn>
                    </template>
                    <v-card>
                    <v-card-title class="headline">
                        <v-spacer></v-spacer>
                        <span class="red--text font-weight-bold">Are You Sure?</span>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <br>
                    <v-card-text class="text-justify">
                        Any work that you have not completed will be lost!
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                        color="red lighten-2"
                        style="color:white"
                        @click="cancelProposal"
                        >YES</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                        color="primary"
                        @click="cancelProposalDialog = false"
                        >NO</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
            
            </v-row>
            </v-card-actions>
        </v-card>
    </div>
</template> 

<script>
import {mapActions, mapGetters} from 'vuex';
import {Proposal,ProposalViewModel} from '@/store/modules/dataModels.js';
import {MEPTierGroup,CustomGroup} from '@/store/modules/proposalBuilderSections.js';
import createNumberMask from 'text-mask-addons/dist/createNumberMask'; 
const currencyMask = createNumberMask({ prefix: '$', allowDecimal: true, includeThousandsSeparator: true, allowNegative: false, });
const numberMask = createNumberMask({ prefix: '', allowDecimal: false, includeThousandsSeparator: true, allowNegative: false, });
const percentMask = createNumberMask({ prefix: '', suffix: '%', allowDecimal: false, includeThousandsSeparator: false, allowNegative: false, });
  
  export default {
    props: {
        // if update mode is true load data
        // otherwise don't
        updateMode: [Boolean],
        context: [Object],
    },
    
    data: () => ({
        develop: false,
        pricingComponentDialog: false,
        cancelProposalDialog: false,

        loi: null,
        duration_selected: 5,
        
        curreMask: currencyMask,
        numMask: numberMask,
        percentageMask: percentMask,
        panel: [0,1,2,3,4,5,6],
        
        revShareAssetThreshold: [], // USE THIS FOR CHECKING FOR ASSET THRESHOLD FOR CALCULATE DISABLE
        plan_opportunity_id: null, // ONLY USE ON UPDATE MODE
        pricingSectionsCompleted: false,
        pricingComplete:[],
        pricingErrors: [],
        
        proposalParameters: {
            plan_runner: {
                plan_runner_name: null,
                plan_runner_id: null
            },
            client: {
                id: null, // UUID
                name: null, // STRING
            },
        },
    }),
    
    mounted () {
        window.scrollTo(0, 0)        
        if (!this.pricingSection.isLoaded){
            this.loadProposalTemplates();
            this.loadRevSharePrograms();
            this.loadBrokerDealers();
            // this.loadDefaultPricing();
            this.loadDefaultPricingOptions();
            this.pricingSection.isLoaded = true;
        }
    },
    
    watch: {           
        client() {
          if(this.client !== null && this.client !== undefined){
            //   console.log("client watcher called")
              this.proposalParameters.client.id = this.client.client_id
              this.proposalParameters.client.name = this.client.client_name
          }  
        },

        'revShareSection.multiQuote'(){
            this.updateSection('revShare');
        },    
        
        'brokerSection.radioSelected'() {
            // console.log('brokerSection.radioSelected watcher');
            this.advisorSection.reset();
            if (this.brokerSection.radioSelected.broker_id !== null){
                this.loadAdvisorState(this.brokerSection.radioSelected.broker_id);
                console.log(this.brokerSection.radioSelected)
                this.advisorSection.brokerSelected = this.brokerSection.radioSelected;
            }
        },

        'brokerSection.dropDownSelected'(){
            // console.log('brokerSection.dropDownSelected watcher');
            this.advisorSection.reset();
            if (this.brokerSection.dropDownSelected === null || typeof(this.brokerSection.dropDownSelected) === 'string') return;
            this.brokerSection.moveSelectedDDLOption();
            this.updateBrokerDefault();
            this.loadAdvisorState(this.brokerSection.radioSelected.broker_id);
        },

        'brokerSection.is_no_broker'() {
            // console.log('brokerSection.is_no_broker watcher');
            this.brokerSection.reset();
            // this.brokerSection.confirmNoBroker = this.brokerSection.is_no_broker;
            if (this.brokerSection.is_no_broker){
                this.brokerSection.confirmNoBroker = true;
            }
        },

        'advisorSection.dropDownSelected'() {
            // console.log('advisorSection.dropDownSelected watcher');
            if (this.advisorSection.dropDownSelected === null 
                || this.advisorSection.dropDownSelected.advisor_name === null) return;
            if (typeof(this.advisorSection.dropDownSelected) === 'string'){
                let broker = this.brokerSection.is_no_broker ? this.brokerSection.no_broker_dealer : this.brokerSection.radioSelected
                this.advisorSection.createAdvisor(broker.broker_id);
            } else {
                this.advisorSection.moveSelectedDDLOption();
            }
        },
        
        'advisorSection.radioSelected'(){
            // console.log('advisorSection.radioSelected watcher');
            if (typeof(this.advisorSection.radioSelected) !== 'string' 
                && typeof(this.advisorSection.radioSelected) !== 'undefined') return;
            if (this.advisorSection.radioSelected === 'Other') {
                this.raiseMessage('To create a new advisor, type their name in the "Other" field. To select an existing advisor, select from the dropdown field.');
            }
        }
    },
    
    computed: {
        ...mapGetters({
            templates: 'getProposalTemplates', //TODO filter for the correct duration
            planTypeSection: 'getPlanTypeSection',
            cashBalanceSection: 'getCashBalanceSection',
            revShareSection: 'getRevShareSection',
            providerSection: 'getProviderSection',
            templateSection: 'getTemplateSection',
            brokerSection: 'getBrokerSection',
            advisorSection: 'getAdvisorSection',
            pricingSection: 'getPricingSection',
            pricingOptions: 'getPricingOptions',
            globalContext: 'globalContext',
            planOpportunityViewmodel: 'getplanOpportunityViewmodel',
            proposalBeingEdited: 'getProposalBeingEdited',
            proposalViewModels: 'getProposalViewModels',

            planOpportunity: 'planOpportunity',
            proposalSettings: 'loadProposalSettings',
            client: 'readClient',
            loiList: 'getLoiList',
            userList: 'userList',
        }),

        disableThreeSixteenBasisPoints(){
            if (this.pricingSection.three_sixteen.is_checked) {
                if (this.pricingSection.three_sixteen.use_basis_points.value) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        },

        disableThreeSixteenCalculations(){
            if (this.pricingSection.three_sixteen.is_checked) {
                if (this.pricingSection.three_sixteen.use_basis_points.value) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },

        disableThreeSixteenEligibleParticipants(){
            if (this.pricingSection.three_sixteen.is_checked){
                if (this.pricingSection.mep_pricing.is_checked || this.pricingSection.three_sixteen.use_basis_points.value){
                    return true;
                }
                if (this.pricingSection.three_sixteen.calculate_on_opt.value == "balance"){
                    return true;
                } else {
                    return false;
                }
            }  else {
                return true;
            }
        },

        disablePlanAssets(){
            return this.planTypeSection.ParentType != "Cash Balance Only" && this.planTypeSection.SubType != "Takeover";
        },
      
        defaultTemplate() {
            let templates = this.globalContext.templatesContext
            let duration = this.duration_selected 
            
            let defaultObj = templates.filter(function(template){
                return template.property.duration == duration;
            });
            return defaultObj[0].proposal.default.template_id;
        },
      
        min_width () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 200;
                case 'sm': return 400;
                case 'md': return 800;
                case 'lg': return 800;
                case 'xl': return 1200;
            }
            return null;
        },      
      
        mobile () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return true;
                case 'sm': return true;
                case 'md': return false;
                case 'lg': return false;
                case 'xl': return false;
            }
            return null;
        },

        showCashBalanceSection(){
            if (this.planTypeSection.isComplete) {
                if (this.planTypeSection.isCBType){
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },

        showTemplateSection(){
            if (this.planTypeSection.isComplete) {
                if (this.planTypeSection.isCBType){
                    if (this.planTypeSection.isCBOnly) return false;
                    return this.cashBalanceSection.isComplete && this.planTypeSection.IsNoRevenueShare;
                } else {
                    return this.planTypeSection.IsNoRevenueShare;
                }
            } else {
                return false;
            }
        },

        showRevShareSection(){
            if (this.planTypeSection.isComplete) {
                if (this.planTypeSection.isCBType){
                    if (this.planTypeSection.isCBOnly) return false;
                    return this.cashBalanceSection.isComplete && !this.planTypeSection.IsNoRevenueShare;
                } else {
                    return !this.planTypeSection.IsNoRevenueShare;
                }
            } else {
                return false;
            }
        },

        showProviderSection(){
            if (this.planTypeSection.IsNoRevenueShare){
                return false;
            } else {
                return this.revShareSection.isComplete
            }
        },

        showBrokerSection(){
            if (this.planTypeSection.IsNoRevenueShare){
                return this.templateSection.isComplete;
            } else if (this.planTypeSection.isCBType){
                return this.cashBalanceSection.isComplete;
            } else {
                return this.providerSection.isComplete;
            }
        },

        showAdvisorSection(){
            return this.brokerSection.isComplete;
        },

        showPricingSection(){
            return this.advisorSection.isComplete;
        },

        pbgcIsDisabled(){
            return !this.planTypeSection.isCBType;
        },
        
        appearEnabled(){
            return this.pricingSection.pbgc.is_checked;
        }
    },
    
    methods: {
        ...mapActions([
            'loadRevSharePrograms',
            'loadProposalTemplates',
            'clearPlanOpportunityViewModelState',
            'clearProposalBuilderState',
            'clearProposalViewModels',
            'loadWholesalerTemplatePairs',
            'loadBrokerDealers',
            'loadDefaultPricing',
            'loadDefaultPricingOptions',
            'getProposalViewModelCalculation',

            'clearPlanOpportunityState',
            'updatePlanOpportunity',
            'loadWholesalers', 
            'loadTemplates',  

            'clearBrokerState',
            'move_brokerDDL_to_brokerRadio',
            'loadBrokerForm',
            'updateBrokerDefaults',

            'loadAdvisorState', 
            'clearAdvisorState', 
            'move_advisorDDL_to_advisorRadio',
            'createAdvisorAndLoadForm',
            'loadAdvisorForm',
            'raiseMessage', 
        ]),

        updatePlanOpp() {
            // console.log('updatePlanOpp')
            let lois = [];
            this.planOpportunityViewmodel.lois.forEach(l => {
                lois.push(l.level_of_involvement_id);
            });
            let obj = {
                'plan_opportunity_id': this.planOpportunityViewmodel.plan_opportunity.plan_opportunity_id,
                'plan_runner_id': this.planOpportunityViewmodel.planRunner.user_id,
                'sales_probability': this.planOpportunityViewmodel.plan_opportunity.sales_probability.slice(0,-1),
                'loi_pops_mapping': lois,
                'duration': this.planOpportunityViewmodel.plan_opportunity.duration
            }
            this.updatePlanOpportunity({'plan_opportunity':obj});
        },
        
        cancelProposal() {
            let one = true;
            if(one){
                this.$router.push({
                    name: 'dashboard'
                })
            }
            this.clearProposalBuilderState();
            this.clearPlanOpportunityViewModelState();
        },
        
        updateBrokerDefault(){
            // console.log('updateBrokerDefault called');
            let defaults = this.brokerSection.defaultIds;
            this.updateBrokerDefaults(defaults);
        },

        selectOtherPricingComponent(component){
            switch(component){
                case 'plan_doc_maint':
                    this.pricingSection.plan_doc_maint.is_checked = this.pricingSection.plan_doc_maint.is_shown;
                    break;
                case 'audit_fee':
                    this.pricingSection.audit_fee.is_checked = this.pricingSection.audit_fee.is_shown;
                    break;
                case 'three_sixteen':
                    this.pricingSection.three_sixteen.is_checked = this.pricingSection.three_sixteen.is_shown;
                    break;
                case 'pbgc':
                    this.pricingSection.pbgc.is_checked = this.pricingSection.pbgc.is_shown;
                    break;
                case 'payroll_integration':
                    this.pricingSection.payroll_integration.is_checked = this.pricingSection.payroll_integration.is_shown;
                    break;
                case 'payroll_processing':
                    this.pricingSection.payroll_processing.is_checked = this.pricingSection.payroll_processing.is_shown;
                    break;
                case 'custom_additions':
                    this.pricingSection.custom_additions.is_checked = this.pricingSection.custom_additions.is_shown;
                    break;
                case 'custom_notes':
                    this.pricingSection.custom_notes.is_checked = this.pricingSection.custom_notes.is_shown;
                    break;
                default:
                    break;
            }
        },
        
        updateSection(sectionName){
            switch(sectionName){
                case 'planType':
                    this.loadDefaultPricing({
                        'planType':this.planTypeSection.planTypeForPricingSelection,
                        'callback':this.updatePlanTypeSection
                    });
                    break;
                case 'cashBalance':
                    break;
                case 'revShare':
                    if (this.revShareSection.isComplete){
                        this.providerSection.defaultTemplate = this.defaultTemplate;
                        this.loadWholesalerTemplatePairs(this.revShareSection.rk_ids);
                    } else {
                        this.providerSection.reset();
                        this.brokerSection.reset();
                        this.advisorSection.reset();
                    }
                    break;
                case 'provider':
                    break;
                case 'broker':
                    break;
                case 'advisor':
                    break;
                case 'pricing':
                    break;
            }
        },
        
        updatePlanTypeSection(){
            this.planTypeSection.setParentType(this.planTypeSection.ParentType);
            this.cashBalanceSection.reset();
            this.revShareSection.reset();
            this.providerSection.reset();
            this.templateSection.reset();
            this.brokerSection.reset();
            this.advisorSection.reset();
            this.pricingSection.reset();

            if (this.planTypeSection.isComplete){
                // console.log('this.planTypeSection.isComplete');
                if (this.planTypeSection.isCBType) {
                    this.cashBalanceSection._planType = this.planTypeSection.ParentType;
                    if (this.planTypeSection.isCBOnly){
                        this.planTypeSection.setDisplayName(this.cashBalanceSection.CBType);
                        if (this.cashBalanceSection.Template === null){
                            this.cashBalanceSection.Template = this.defaultTemplate;
                        }
                    }
                } else {
                    this.pricingSection.pbgc.is_checked = false;
                    this.pricingSection.pbgc.is_shown = false;
                }

                if (this.planTypeSection.IsNoRevenueShare && this.templateSection.Template === null){
                    this.templateSection.Template = this.defaultTemplate;
                }
            }

            if (this.planTypeSection.SubType === 'Takeover'){
                this.pricingSection.is_takeover = true;
            } else {
                this.pricingSection.is_takeover = false;
            }
            
            if (this.planTypeSection.IsMEP){
                // console.log("this.planTypeSection.IsMEP")
                // console.log(this.pricingSection)
                this.pricingSection.pricing_assumptions.is_shown = false;
                this.pricingSection.pricing_assumptions.is_checked = false;
                this.pricingSection.standard_fees.is_shown = false;
                this.pricingSection.standard_fees.is_checked = false;
                this.pricingSection.mep_pricing.is_shown = true;
                this.pricingSection.mep_pricing.is_checked = true;
                this.pricingSection.three_sixteen.setForMEP(true);
                this.pricingSection.pbgc.setForMEP(true);                        
            } else {
                this.pricingSection.pricing_assumptions.is_shown = true;
                this.pricingSection.pricing_assumptions.is_checked = true;
                this.pricingSection.standard_fees.is_shown = true;
                this.pricingSection.standard_fees.is_checked = true;
                this.pricingSection.mep_pricing.is_shown = false;
                this.pricingSection.mep_pricing.is_checked = false;
                this.pricingSection.pbgc.setForMEP(false);
            }
        },

        updateAdvisorObj(){
            console.log("updateAdvisorObj called");
            this.advisorSection.updateAdvisor();
        },

        updateAdvisorBroker(){
            console.log("updateAdvisorBroker called");
            let broker = this.brokerSection.is_no_broker ? this.brokerSection.no_broker_dealer : this.brokerSection.radioSelected
            this.advisorSection.updateAdvisor(this.advisorSection.brokerSelected.broker_id);
            this.advisorSection.reset();
            this.loadAdvisorState(broker.broker_id);
            this.advisorSection.brokerSelected = broker;
            this.advisorSection.confirm = false;
        },

        handleNoBrokerSelect(response){
            console.log("handleNoBrokerSelect called");
            if (response){
                console.log(response);
                this.loadAdvisorState(this.brokerSection.no_broker_dealer.broker_id);
                this.advisorSection.brokerSelected = this.brokerSection.no_broker_dealer;
            } else {
                console.log(response);
                this.brokerSection.is_no_broker = false;
            }
            this.brokerSection.confirmNoBroker = false;
        },

        getCalculations(){
            this.buildProposalViewModels().forEach(vm => {
                // console.log(vm);
                this.getProposalViewModelCalculation(vm);
            });
            this.goToReview();
        },

        goToReview(){
            // console.log('goToReview called');
            let emitObj = {
                showComp: 'Review',
                duration: this.duration_selected
            }
            this.$emit('return', emitObj);
        },

        buildProposalViewModels(){
            // console.log('buildProposalViewModels called');
            let proposalVMs = [];
            let planType = this.planTypeSection.toJson();
            let priceForm = this.pricingSection.toJson();
            // console.log(this.planOpportunityViewmodel);
            this.buildPackets().forEach(pac => {
                let prop = new Proposal({
                    'proposal_id': null,
                    'predecessor_id': this.proposalBeingEdited.proposal_id,
                    'plan_opportunity_id': this.planOpportunityViewmodel.plan_opportunity.plan_opportunity_id,
                    'client_id': this.planOpportunityViewmodel.plan_opportunity.client_id,
                    'plan_type_id': planType.plan_type_id,
                    'broker_id': this.brokerSection.brokerId,
                    'advisor_id': this.advisorSection.radioSelected.advisor_id,
                    'rk_id': pac.rk_id,
                    'wholesaler_id': pac.wholesaler_id,
                    'template_id': pac.template_id,
                    'rep_user_id': pac.rep_user_id,
                });
                proposalVMs.push(new ProposalViewModel({
                    'packet': pac,
                    'proposal': prop,
                    'plan_type': planType,
                    'price_form': priceForm,
                }));
            });
            return proposalVMs;
        },

        buildPackets(){
            // console.log('getPackets called');
            if (this.planTypeSection.isCBOnly){
                return [this.cashBalanceSection.packet];
            } else if (this.planTypeSection.IsNoRevenueShare){
                return [this.templateSection.packet];
            } else {
                return this.revShareSection.getPackets(this.providerSection.wholesalerTemplates);
            }
        },

        resetTierMEPPricing(){
            this.pricingSection.mep_pricing.groups = [];
            if (this.pricingSection.mep_pricing.details && this.pricingSection.mep_pricing.details.length > 0){
                for (let i = 1; i <= this.pricingSection.mep_pricing.details.length / 5; i++){
                    let group = {
                        'custom_group': i,
                        'tier_level': this.pricingSection.mep_pricing.details.find(d => d.custom_group == `${i}` && d.detail_name == 'tier_level'),
                        'per_company': this.pricingSection.mep_pricing.details.find(d => d.custom_group == `${i}` && d.detail_name == 'per_company'),
                        'company_count': this.pricingSection.mep_pricing.details.find(d => d.custom_group == `${i}` && d.detail_name == 'company_count'),
                        'per_participant': this.pricingSection.mep_pricing.details.find(d => d.custom_group == `${i}` && d.detail_name == 'per_participant'),
                        'participant_count': this.pricingSection.mep_pricing.details.find(d => d.custom_group == `${i}` && d.detail_name == 'participant_count'),
                    }
                    this.pricingSection.mep_pricing.groups.push(new MEPTierGroup(group));
                }
            } else {
                this.pricingSection.mep_pricing.groups.push(new MEPTierGroup());
            }
        },

        removeUnusedMEPTiers(){
            this.pricingSection.mep_pricing.groups.forEach(() => {
                let remainingGroups = []
                for (let i = 0; i < this.pricingSection.mep_pricing.groups.length; i++){
                    let g = this.pricingSection.mep_pricing.groups[i];
                    if (g.company_count.value || g.participant_count.value) remainingGroups.push(g);
                }
                if (remainingGroups.length == 0){
                    remainingGroups.push(new MEPTierGroup());
                }
                this.pricingSection.mep_pricing.groups = remainingGroups;
            });
        },

        // addMEPTier(){
        //     this.pricingSection.mep_pricing.groups.push(new MEPTierGroup());
        // }

        addCustomAddition(){
            let i = this.pricingSection.custom_additions.groups.length;
            this.pricingSection.custom_additions.groups.push(new CustomGroup({'custom_group':i}));
        },

        addCustomNote(){
            let i = this.pricingSection.custom_notes.groups.length;
            this.pricingSection.custom_notes.groups.push(new CustomGroup({'custom_group':i}));
        },
    }
  };
</script>

<style type="text/css" scoped>
    .pricingComponentSelectEmpty {
        text-align: center;
        margin-top: 20px;
        font-size: 20px;
        line-height: 30px;
        overflow-y: hidden;
    }
    .appearEnabled >>> label, .appearEnabled >>> input, .appearEnabled >>> div::before {
        color: rgb(0,0,0,.68) !important;
        border-color: rgb(0,0,0,.43) !important;
        border-image: none !important;
    }
    hr{
        border: none;
        border-top: solid 2px #ccc;
    }
    .componentList{
        margin-top: 0 !important;
        padding-top: 0 !important;
    }
    .not-caps{
        text-transform: none !important;
    }
    .text{
        font-size: 18px;
        padding-top: 10px;
        margin-top: 16px;
    }
    .mep-title{
        font-size: 20px;
        padding-top: 22px;
    }
    .section{
        min-width: 100%;
    }
    .section-title{
        bottom-right-border-radius: 0;
        bottom-left-border-radius: 0;
    }
    .component_selector{
        padding: 0 20px 0 0;
    }
    .provider-section{
        background-color: #d6d6d6;
    }
    .rounded-card{
        border-radius: 20px !important;
    }
    
    .shadow {
        box-shadow: 0px 0px 10px -2px !important;
    }
    
    .theme--light.v-sheet--outlined {
        border: thin solid rgb(0,0,0,30%);
    }
    .center {
        align-items: center;
    }
    .error-msg {
        border-radius: 3px;
        color: white;
        background: #FFADAD;
        padding: 4px;
        margin-top: 1px;
        width: 100%;
        font-weight: 300;
    }
</style>
